import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { forkJoin, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { IApplicationStep } from '../models/application-step.interface';
import { ApiResponse, SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'online-app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.css']
})
export class SidebarNavComponent implements OnInit, OnDestroy {

  applicationId: number;
  currentSectionURL = '';
  isSubmittedApplication = false;

  applicationSteps: IApplicationStep[] = [];
  isAgent: boolean;
  subscriptions: Subscription[] = [];

  constructor(private store: Store<any>,
    private router: Router,
    private applicationService: ApplicationService,
    private activatedRoute: ActivatedRoute) {
    this.subscriptions.push(this.activatedRoute.params.subscribe(params => {
      this.applicationId = +params['id']; // (+) converts string 'id' to a number
    }));
  }


  ngOnInit() {

    this.applicationSteps = this.applicationService.getApplicationSteps();

    forkJoin(
      this.applicationService.getApplicationSections(this.applicationId)
        .pipe(
          catchError(err => {console.log(err); return null}),
          tap((response: ApiResponse) => this.updateApplicationSectionStatus(response.Result))
        ),

      this.applicationService.getApplicationDetails(this.applicationId)
        .pipe(
          catchError(err => {console.log(err); return null}),
          tap((response: SingleResultApiResponse) => {
            this.isAgent = !!response.Result.AgencyOrBranchId;
            this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';
            localStorage.setItem("isAgent", this.isAgent.toString());
          })
        )
    ).subscribe(() => {      
      if (!this.isAgent) {
        this.applicationSteps = this.applicationSteps.filter(s => s.Section !== 'AgentDetails');
      }

      if (this.isSubmittedApplication) {
        this.applicationSteps = this.applicationSteps.filter(x => x.Status == 'Complete');
      }
    });

    this.subscriptions.push(this.store.pipe(select('application'))
      .subscribe(applicationState => {

        if (applicationState && applicationState.applicationSectionSaved && this.applicationId > 0) {
          this.applicationService.getApplicationSections(this.applicationId)
            .subscribe((response: ApiResponse) => {
              this.updateApplicationSectionStatus(response.Result);
            }, err => {
              console.error(err);
            });
        }

      }));

  }

  navigateTo(urlObj: string[]) {
    const startTime = Date.now();
    this.router.navigate(urlObj);

    console.log(`side nav click: ${urlObj[urlObj.length - 1]}. time elapsed ${(Date.now() - startTime).toString()}ms`);
  }

  updateApplicationSectionStatus(applicationSections: ApplicationSection[]) {

    for (const applicationStep of this.applicationSteps) {
      const applicationSection = applicationSections.find(applnSection => applnSection.Type === applicationStep.Section);

      if (applicationSection) {
        applicationStep.Status = applicationSection.Status;
      } else {
        applicationStep.Status = 'NotStarted';
      }
    }
    const summaryApplicationStep = this.applicationSteps.find(s => s.Id === 10);
    const stepsBeforeSummarySection = this.applicationSteps.filter(s => s.Id > 1 && s.Id <= 9);

    if (summaryApplicationStep) {
      summaryApplicationStep.Status = stepsBeforeSummarySection.every(s => s.Status === 'Complete') ? 'Complete' : 'NotStarted';
    }
  }

  getCSSClassForApplicationSectionStatus(sectionStatus: string, url: string): string {

    let cssClass = '';
    if (url === 'important-information') {
      cssClass = 'complete';
    } else if (sectionStatus === 'Complete') {
      cssClass = 'complete';
    } else if (sectionStatus === 'Invalid') {
      cssClass = 'incomplete';
    } else if (sectionStatus === 'NotStarted') {
      cssClass = '';
    } else if (sectionStatus === 'NotStarted') {
      cssClass = '';
    }

    if (this.router.url.split('/').includes(url)) {
      cssClass += ' on';
    }

    return cssClass;

  }

  showPaymentSection(sectionStatus: string, url: string): boolean {
    if (url === 'payment' && sectionStatus === 'Complete') {
      return false;
    }
    return true;
  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.border = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.border = "";
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
